export const FEATURES = [
  { icon: 'checkmark-circle', text: 'Unlimited mood check-ins', color: '#4D96FF' },
  { icon: 'mic', text: 'Voice check-in with AI analysis', color: '#9B59B6' },
  { icon: 'heart', text: '100+ coping skills library', color: '#E91E63' },
  { icon: 'sparkles', text: 'AI chat companion', color: '#F39C12' },
  { icon: 'shield-checkmark', text: 'Safety plan & crisis tools', color: '#E74C3C' },
  { icon: 'trophy', text: 'Gamification & achievements', color: '#27AE60' },
  { icon: 'calendar', text: 'Mood calendar & insights', color: '#00BCD4' },
  { icon: 'infinite', text: 'Lifetime access - no subscription', color: '#6BCB77' },
];

